import { render, staticRenderFns } from "./ValidationIniziative.vue?vue&type=template&id=76c267b1&scoped=true&"
import script from "./ValidationIniziative.vue?vue&type=script&lang=ts&"
export * from "./ValidationIniziative.vue?vue&type=script&lang=ts&"
import style0 from "./ValidationIniziative.vue?vue&type=style&index=0&id=76c267b1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c267b1",
  null
  
)

export default component.exports